var favouriteService = require('favouriteService'),
    contentService = require('contentService'),
    loader = require('loader'),
    notification = require('notification');

const favourite = (function() {

    var $favBtn = $('.fav-btns a'),
        $activeBtn = null,
        $contentPageFavBtns = $('.content-item-sidebar .fav-btns');

    var favouriteClick = function() {
        $favBtn.on('click', function(e) {
            e.preventDefault();

            //This is to prevent firing the API off multiple times if people spam the button
            if (!$(this).hasClass('clicked-link')) {
                $('window').showLoader();

                $activeBtn = $(this).closest($('.fav-btns'));

                var modelType = $activeBtn.attr('data-model-type'),
                    modelID = $activeBtn.attr('data-model-id');

                $(this).addClass('clicked-link');

                if ($(this).hasClass('favourited')) {
                    deleteFavouriteService(modelID, modelType, favouriteMessage);
                } else if ($(this).hasClass('not-favourited')) {
                    addFavouriteService(modelID, modelType, favouriteMessage);
                }
            }
        });
    };


    var favouriteMessage = function(response) {
        if (response.statusCode === 200) {
            $('window').notification({ title: response.message });
            toggleActiveBtn();
        } else {
            $('window').notification({ title: response.message, error: true });
            $('.active').removeClass('clicked-link');
        }
    };


    var toggleActiveBtn = function() {
        //Slide buttons (used on content teasers) need an extra class to accommodate the animation
        if ($activeBtn.hasClass('slide-btns')) {
            $('.clicked-link').addClass('removing-active');
            //Need to use .one here as the link has a transition on hover and we don't want the listener constantly listening and firing
            $('.removing-active').one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
                $(this).removeClass('active clicked-link removing-active').siblings().addClass('active');
            });
        } else {
            $('.clicked-link').removeClass('active clicked-link').siblings().addClass('active');
        }
    };


    var onContentPage = function() {
        //If we're on a content page (drill, session, guide etc) then we call an API to see if the content is favourited by the user
        if ($contentPageFavBtns.length) {
            var modelType = $contentPageFavBtns.attr('data-model-type'),
                modelID = $contentPageFavBtns.attr('data-model-id');

            isFavouriteService(modelID, modelType, checkIfFavourited);
        }
    };


    var checkIfFavourited = function(response) {
        if (response.statusCode === 200) {
            if (response.data === true) {
                $('.content-item-sidebar').find('.content-not-favourited').hide();
                $('.content-item-sidebar').find('.content-favourited').show();
            }
        }
    };


    const init = function() {
        if ($favBtn.length) {
            favouriteClick();
            onContentPage();
        }
    };

    return {
        init: init
    };

})();

favourite.init();



// WEBPACK FOOTER //
// ./library/js/modules/favourite.js